var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('frip-alert-modal-container'),(_vm.provider === 'KAKAO_SYNC')?_c('frip-button',{staticClass:"my-1",style:({
      width: '100%',
      background: '#FEE646',
      borderStyle: 'none',
    }),on:{"click":_vm.loginWithKakao}},[_vm._v("카카오톡으로 시작하기")]):_vm._e(),(_vm.provider === 'FACEBOOK')?_c('frip-button',{staticClass:"my-1",staticStyle:{"width":"100%"},attrs:{"type":"primary"},on:{"click":_vm.loginWithFacebook}},[_vm._v("페이스북으로 시작하기")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }